import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebook } from '@fortawesome/free-brands-svg-icons';
import './styles/Footer.css';

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-section">
          <h3>JBC Entreprenøren ApS</h3>
          <p>Naurvej 6, Undløse</p>
          <p>4340 Tølløse</p>
          <p>CVR nr. 44384345</p>
          <p>Tlf: 22780476</p>
          <p>Email: jbc@jbcentreprenoeren.dk</p>
        </div>
        <div className="footer-section">
          <h3>Tjenester</h3>
          <ul>
            <li><Link to="/jordvarme">Jordvarme</Link></li>
            <li><Link to="/belægning">Belægning</Link></li>
            <li><Link to="/midlertidig-vej">Midlertidig Vej</Link></li>
            <li><Link to="/fundamenter">Fundamenter</Link></li>
            <li><Link to="/tilbygning">Tilbygning</Link></li>
            <li><Link to="/lca">LCA &amp; Bæredygtighed</Link></li>
          </ul>
        </div>
        <div className="footer-section">
          <h3>Hurtige links</h3>
          <ul>
            <li><Link to="/">Hjem</Link></li>
            <li><Link to="/om-os">Om os</Link></li>
            <li><Link to="/kontakt">Kontakt</Link></li>
          </ul>
        </div>
        <div className="footer-section">
          <h3>Følg os</h3>
          <div className="social-icons">
            <a href="https://www.facebook.com/p/Jbc-Entrepern%C3%B8ren-100085100491591/" target="_blank" rel="noopener noreferrer">
              <FontAwesomeIcon icon={faFacebook} />
            </a>
          </div>
        </div>
      </div>
      <div className="footer-bottom">
        <p>&copy; {new Date().getFullYear()} Parla Branding. Alle rettigheder forbeholdes.</p>
        <p>Skabt af <a href="https://www.parlabranding.dk" target="_blank" rel="noopener noreferrer">Parla Branding</a></p>
      </div>
    </footer>
  );
}

export default Footer;
